import { SCENARIO_LIBRARY_DATA, SCENARIO_OUTPUT_DATA } from '../utils/dataConstants';

export interface AudioMappedDataRow {
  States: string;
  Category: string;
  Bottler: string;
  Brand: string;
  Pack_Segment: string;
  Packsize: string;
  Base_Price: string;
  New_Price: string;
  Distribution: string;
  Action: string;
}

export interface InputMappedDataRow {
  State: string;
  Category: string;
  Bottler: string;
  Brand: string;
  Pack_Segment: string;
  Pack_Size: string;
  New_Price: string;
  New_Distribution: string;
  Current_Price: string;
  Current_Distribution: string;
  Action: string;
}

export interface DataRow {
  States: string;
  Category: string;
  Bottler: string;
  Brand: string;
  Pack_Segment: string;
  Packsize: string;
  Base_Price: string;
  New_Price: string;
  Distribution: string;
  Action: string;
}

export const staticAudioResultData: AudioMappedDataRow[] = [
  {
    States: '--',
    Category: '--',
    Bottler: '--',
    Brand: '--',
    Pack_Segment: '--',
    Packsize: '--',
    Action: '--',
    Base_Price: '--',
    New_Price: '--',
    Distribution: '--',
  },
];

export const staticInputResultData: InputMappedDataRow[] = [
  {
    State: '--',
    Category: '--',
    Bottler: '--',
    Brand: '--',
    Pack_Segment: '--',
    Pack_Size: '--',
    New_Price: '--',
    New_Distribution: '--',
    Current_Price: '--',
    Current_Distribution: '--',
    Action: '--',
  },
];

export type SelectMapperKeys = keyof typeof SCENARIO_OUTPUT_DATA.SELECT_MAPPER;
export type ViewByMapperKeys = keyof typeof SCENARIO_OUTPUT_DATA.VIEW_BY_MAPPER;
export type StatusMapperKeys = keyof typeof SCENARIO_LIBRARY_DATA.STATUS_MAPPER;
export type ViewByMapperKeysForDeepdive = keyof typeof SCENARIO_OUTPUT_DATA.VIEW_BY_MAPPER_DEEPDIVE;
